<template>
    <b-button :disabled="pending" @click="dispatchExport">
        <slot>
            {{ label }}
            <b-spinner v-if="pending" class="ml-1" small />
            <fa v-else :icon="icon" class="ml-1" />
        </slot>
    </b-button>
</template>
<script>
    export default {
        name: 'ExportButton',
        props: {
            apiUrl: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default() {
                    return this.$t('Export')
                }
            },

            icon: {
                type: String,
                default: 'file-export'
            }
        },

        data: function () {
            return {
                pending: false,
            };
        },

        methods: {
            dispatchExport() {
                if (this.pending) return;

                this.pending = true;

                this.axios
                    .get(this.apiUrl)
                    .then(({data}) => this.successToast(data.message))
                    .catch(e => e.response || throw e)
                    .finally(() => this.pending = false)
            },
        }
    }
</script>
